import { useState } from 'react'

import { Input } from 'antd'
import { faCity, faComment, faEnvelope, faGlobe, faIdBadge, faIdCard, faLocationArrow, faSave } from '@fortawesome/pro-solid-svg-icons'
import { useSelector } from 'react-redux'

import FormItem from '../../../Components/shared/Forms/FormItem'
import { Properties } from '../../../utils/entities'
import { getErrors, getFormError, getIdOrNull, handleStateSelectId } from '../../../utils'
import IconButton from '../../../Components/antd/Buttons/IconButton'
import { isValid } from '../../../utils/validators'
import { Institution, INSTITUTION_VALIDATORS } from '../../../utils/entities/institution'
import CountriesSelector from '../../../Components/shared/Selectors/CountriesSelector'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'

const { ACRONYM, ADDRESS, CITY, COUNTRY, GLOBAL_MESSAGE, NAME, ZIPCODE } = Properties
/** @enum */
export const Modes = Object.freeze({
  DEFAULT: 'DEFAULT',
  LIGHT: 'LIGHT'
})

const InstitutionForm = ({ data, onSubmit, mode = Modes.DEFAULT }) => {
  const t = useSelector(selectTranslate)

  const [formData, setFormData] = useState({ ...data })
  const [error, setError] = useState({ missingFields: [] })

  const handleSubmit = () => {
    const institution = new Institution(formData)

    const errors = isValid(institution, INSTITUTION_VALIDATORS([ACRONYM, COUNTRY, NAME]))

    if (errors.keys.length === 0) {
      onSubmit(institution)
    } else {
      const details = {}

      Object.keys(errors.messages).forEach(key => {
        details[t(key)] = errors.messages[key].map(m => t(m))
      })

      setError({
        ...error,
        details,
        missingFields: errors.keys
      })
    }
  }

  const errors = getErrors(error)

  return (
    <>
      <div className='flex-column w-100'>
        <FormItem icon={faIdCard} label='common.name.dd' required>
          <Input
            className={getFormError(errors[NAME])}
            value={formData[NAME]}
            onChange={e => setFormData({ ...formData, [NAME]: e.target.value })}
          />
        </FormItem>
        <FormItem icon={faIdBadge} label='common.acronym.dd' required>
          <Input
            className={getFormError(errors[ACRONYM])}
            value={formData[ACRONYM]}
            onChange={e => setFormData({ ...formData, [ACRONYM]: e.target.value })}
          />
        </FormItem>
        <FormItem icon={faGlobe} label='common.country.dd' className='form-select' required>
          <CountriesSelector
            className={getFormError(errors[COUNTRY])}
            values={getIdOrNull(formData.country)}
            onChange={handleStateSelectId(setFormData, COUNTRY)}
          />
        </FormItem>
        {mode === Modes.DEFAULT && (
          <FormItem icon={faComment} label='common.global_message.dd'>
            <Input value={formData[GLOBAL_MESSAGE]} onChange={e => setFormData({ ...formData, [GLOBAL_MESSAGE]: e.target.value })} />
          </FormItem>
        )}
        <FormItem icon={faLocationArrow} label='common.address.dd'>
          <Input value={formData[ADDRESS]} onChange={e => setFormData({ ...formData, [ADDRESS]: e.target.value })} />
        </FormItem>
        <FormItem icon={faCity} label='common.city.dd'>
          <Input value={formData[CITY]} onChange={e => setFormData({ ...formData, [CITY]: e.target.value })} />
        </FormItem>
        <FormItem icon={faEnvelope} label='common.zipcode.dd'>
          <Input value={formData[ZIPCODE]} onChange={e => setFormData({ ...formData, [ZIPCODE]: e.target.value })} />
        </FormItem>
      </div>
      <div className='flex-row w-100 j-ctn-e'>
        <IconButton type='primary' icon={faSave} onClick={handleSubmit} text={t('actions.save')} />
      </div>
    </>
  )
}

export default InstitutionForm
